import * as React from 'react'
import styles from './styles.module.css'

/* The DotDotDot is an animated ellipsis for things like `Logging out...` where the dots imply async progress */
const DotDotDot = (props: {children: string}) => (
  <p className={styles.loading}>{props.children}</p>
)

export default DotDotDot
